import React, { useState } from 'react';
import styled from 'styled-components';
import { SwapWidget } from '@relayprotocol/relay-kit-ui';
import { useConnectModal } from '@rainbow-me/rainbowkit';
import { useWalletClient } from 'wagmi';
import { adaptViemWallet } from '@relayprotocol/relay-sdk';

const WidgetContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const WidgetTitle = styled.h3`
  font-size: 16px;
  font-weight: 600;
  color: #ffffff;
  margin-bottom: 12px;
  font-family: 'Inter', sans-serif;
  text-align: center;
`;

const PoweredBy = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  margin-top: 20px;
  color: #9ca3af;
  font-size: 12px;
`;

const RelayLogo = styled.img`
  height: 16px;
  width: auto;
  opacity: 0.8;
`;

// ETH on Mainnet (default from)
const ETH_MAINNET = {
  chainId: 1,
  address: '0x0000000000000000000000000000000000000000',
  decimals: 18,
  name: 'Ethereum',
  symbol: 'ETH',
  logoURI: 'https://icons.llamao.fi/icons/chains/rsz_ethereum.jpg'
};

// ETH on Ink L2 (locked to)
const ETH_INK = {
  chainId: 57073,
  address: '0x0000000000000000000000000000000000000000',
  decimals: 18,
  name: 'Ethereum',
  symbol: 'ETH',
  logoURI: 'https://icons.llamao.fi/icons/chains/rsz_ink.jpg'
};

const BridgeToETHWidget: React.FC = () => {
  const { openConnectModal } = useConnectModal();
  const { data: walletClient } = useWalletClient();
  
  const [fromToken, setFromToken] = useState(ETH_MAINNET);
  const [toToken] = useState(ETH_INK); // Don't expose setter

  return (
    <WidgetContainer>
      <WidgetTitle>Bridge to Ink</WidgetTitle>
      <SwapWidget
        wallet={walletClient ? adaptViemWallet(walletClient) : undefined}
        supportedWalletVMs={['evm']}
        fromToken={fromToken}
        setFromToken={(token) => token && setFromToken(token as any)}
        toToken={toToken}
        setToToken={() => {}} // No-op, locked
        lockToToken={true}
        onConnectWallet={openConnectModal}
        onAnalyticEvent={(eventName, data) => {
          console.log('Bridge to ETH Analytics:', eventName, data);
        }}
        onSwapSuccess={(data) => {
          console.log('Bridge to ETH successful:', data);
        }}
        onSwapError={(error) => {
          console.error('Bridge to ETH error:', error);
        }}
      />
      
      <PoweredBy>
        <span>powered by</span>
        <RelayLogo src="/lockup_white.svg" alt="Relay Protocol" />
      </PoweredBy>
    </WidgetContainer>
  );
};

export default BridgeToETHWidget;

